<template>
  <div id="app">
    <Header></Header>
    <router-view style="margin-top: 120px"></router-view>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
</style>
